<template>
  <Header headerShadow="header__area header__padding header__shadow" />
  <section class="page__title-area pt-90 pb-90">
    <div class="page__title-shape">
      <img class="page-title-shape-5 d-sm-block" src="../assets/img/page-title/page-title-shape-1.png" alt="">
      <img class="page-title-shape-6" src="../assets/img/page-title/page-title-shape-6.png" alt="">
      <img class="page-title-shape-7" src="../assets/img/page-title/page-title-shape-4.png" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="course__wrapper">
            <div class="page__title-content pt-90 mb-25">
              <div class="page__title-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/">{{ $t('actions.home') }}</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ $t('actions.videoList') }}</li>
                  </ol>
                </nav>
              </div>
              <h5 class="page__title-3" style="font-size: 35px">{{ $t('actions.videoList') }}</h5>
            </div>

            <div class="course__tab-content">
              <div class="tab-content" id="courseTabContent">
                <div class="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="description-tab">
                  <div class="course__description px-0 row">
                    <div v-for="(vm,index) in embedList" :key="index" class="col-6 mb-4">
                      <div style="cursor: pointer">
                        <iframe ref="videoIframe" width="250px" height="170px" frameborder="0" allowfullscreen :src="vm.embed"></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="float-end">
              <b-pagination v-model="params.page" :total-rows="videos.totalItems" :per-page="videos.size"></b-pagination>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Footer -->
  <Footer footerPadding="true"/>
</template>

<script>
import Header from '../components/HomeTwo/Header.vue';
import Footer from '../components/Home/Footer.vue';
import CourseItemMixin from '../mixins/courseItemsMixin';
// import CourseSidebar from '../components/CourseDetails/CourseSidebar.vue';
import {Swiper, SwiperSlide} from "swiper/vue";
import { Pagination } from "swiper";
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '@/mixins/blogMixin';


export default {
  name: "CourseDetailsPage",
  components:{
    Swiper,
    SwiperSlide,
    Header,
    // CourseSidebar,
    Footer
  },
  mixins: [CourseItemMixin, BlogMixin],
  data() {
    return {

      params:{
        page: 1,
        size:6
      },
    }
  },
  watch:{
    'params.page':{
      handler(){
        this.getVideos(this.params);
      }
    }
  },
  created() {
    this.getVideos(this.params);
  },
  computed:{
    ...mapGetters('videos', ["videos"]),
    embedList() {
      return (this.videos?.results)?.map(url => {
        const id = (url.video)?.split("v=")[1];
        return {
          ...url,
          embed: `https://www.youtube.com/embed/${id}`,
        };
      });
    }
  },
  methods: {
    ...mapActions('videos', ["getVideos"]),
  }
};
</script>

<style scoped lang="css">
.course__description{
  width: 100%;
  padding: 20px 15px;
  border-radius: 8px;
}
.circle__image {
  width: 330px;
  height: 330px;
  object-fit: cover;
  object-position: center;
  border: 1px solid rgba(128, 128, 128, 0.1);
  box-shadow: 0 0 0 0 rgba(255,255,255, 0.4);
  padding: 10px;
  border-radius: 3px;
}

</style>
